import http from '@/libs/axios'

export const ParticipantService = {
  /**
   * Atualiza a lista de participantes via arquivo
   * @param {File} file
   */
  async updateViaFile(file) {
    const data = new FormData()
    data.append('file', file)
    return http.post('participants/update', data)
  },
}
